import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { Popconfirm } from "antd";
import FunctionalInput from "components/common/FunctionalInput";
import FunctionalButton from "components/common/FunctionalButton";

import {
    editDraft,
    deleteDraft
} from "actions/draftActions";
import { defaultHandleInputChange } from "utils/constant";

class TopBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            draftName: "",
            draftIsInactive: false
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => (
                <div className="text-danger position-absolute">{message}</div>
            )
        });

        this.defaultHandleInputChange = defaultHandleInputChange.bind(this);
        this.handleClickSave = this.handleClickSave.bind(this);
        this.handleClickDelete = this.handleClickDelete.bind(this);
        this.handleClickIsInactive = this.handleClickIsInactive.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.draft !== this.props.draft) {
            this.setState({
                draftName: this.props.draft.name,
                draftIsInactive: this.props.draft.isInactive
            });
        }
    }

    handleClickSave() {
        if (this.validator.allValid()) {
            const { draftName, draftIsInactive } = this.state;
            this.props.editDraft(this.props.draft.id, draftName, draftIsInactive);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleClickDelete() {
        this.props.deleteDraft(this.props.draft.id);
    }

    handleClickIsInactive() {
        this.setState({
            draftIsInactive: !this.state.draftIsInactive
        });
    }

    render() {
        const { draft } = this.props;
        const { draftName, draftIsInactive } = this.state;
        const buttonStyle = {
            width: 140
        };
        return (
            <form autoComplete="off" role="presentation">
                <Row className="d-flex flex-wrap justify-content-around mt-2">
                    <Col md={3} className="d-flex flex-wrap justify-content-between">
                        <FunctionalInput
                            label="Name"
                            type="text"
                            name="draftName"
                            className="mr-4"
                            value={draftName}
                            disabled={false}
                            validator={this.validator}
                            onChange={this.defaultHandleInputChange}
                        />
                    </Col>
                    <Col md={1} className="d-flex flex-wrap  justify-content-between">
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={draftIsInactive}
                                onChange={this.handleClickIsInactive}
                            />
                            <span>Is Inactive</span>
                        </div>
                    </Col>
                    <Col md={3} className="d-flex flex-wrap  justify-content-between">
                        <FunctionalInput
                            label="Retailer"
                            type="text"
                            name="retailer"
                            value={draft.retailer}
                            disabled={true}
                        />
                    </Col>
                    <Col
                        md={{ span: 1, offset: 1 }}
                        className="d-flex flex-wrap  justify-content-between"
                    >
                        <FunctionalButton
                            variant="success"
                            value="Save"
                            onClick={this.handleClickSave}
                            style={buttonStyle}
                            className="mr-4"
                        />
                    </Col>

                    <Col md={1} className="d-flex flex-wrap  justify-content-between">
                        <Popconfirm
                            title="Removing draft. Are you sure?"
                            onConfirm={this.handleClickDelete}
                            placement="bottom"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <FunctionalButton
                                variant="danger"
                                className="mr-4"
                                value="Delete"
                                style={buttonStyle}
                            />
                        </Popconfirm>
                    </Col>

                    <Col md={1} className="d-flex flex-wrap  justify-content-between">
                        <FunctionalButton
                            variant="primary"
                            value="Cancel"
                            className="mr-4"
                            style={buttonStyle}
                            onClick={() => {
                                this.props.history.push("/schedule/drafts");
                            }}
                        />
                    </Col>
                </Row>
            </form>
        );
    }
}

TopBar.propTypes = {
    draft: PropTypes.object.isRequired,
    editDraft: PropTypes.func.isRequired,
    deleteDraft: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    draft: state.draft.draft
});

const mapStateToDispatch = dispatch => ({
    editDraft: bindActionCreators(editDraft, dispatch),
    deleteDraft: bindActionCreators(deleteDraft, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TopBar);
